import { Box, Typography } from "@mui/material";
import { INavbarIconVariant, NavbarIcon } from "../../atoms/navbar/Icon";

type QuestionIconIndexProps = {
  icon: INavbarIconVariant;
  bgcolor: string;
  color: string;
  index?: string;
  fill?: string;
  width?: string;
};

export const QuestionIconIndex = (props: QuestionIconIndexProps) => {
  const { icon, bgcolor, color, fill, index, width = "48px" } = props;

  return (
    <Box
      display="flex"
      padding="4px"
      width={width}
      height="24px"
      borderRadius="2px"
      bgcolor={bgcolor}
      alignItems="center"
      justifyContent="space-between"
      gap="8px"
    >
      <NavbarIcon
        variant={icon}
        color={color}
        sx={{
          width: "16px",
          height: "16px",
          minHeight: "16px",
          minWidth: "16px",
          fill: fill,
        }}
      />
      {index && (
        <Typography variant="h5" color={color}>
          {index}
        </Typography>
      )}
    </Box>
  );
};
